import { Icon } from './Icon';

// A filter HANDED to the page rather than chosen on it (the Date window from
// Daily's "Open in Bookings"; viewings-in-the-bookings-list AC11). The filter
// pill's family, one glyph apart — and ONLY THE × IS A CONTROL (Sir,
// 2026-09-02): the pill itself is a statement, not a button, so nothing happens
// on a click that lands on the words; the × clears it and says so on hover.
export interface DismissPillProps {
  label: string;
  value: string;
  onDismiss: () => void;
  icon?: string;
}

export function DismissPill({ label, value, onDismiss, icon }: DismissPillProps) {
  return (
    <div className="filterctl">
      <span className="fc-pill on fc-static">
        {icon && <Icon name={icon} size={13} className="fc-ico" />}
        <span className="fc-type">{label}:</span>
        <span className="fc-val">{value}</span>
        <button type="button" className="fc-dismiss" title="Clear" aria-label={`Clear ${label}: ${value}`} onClick={onDismiss}>
          <Icon name="close" size={14} />
        </button>
      </span>
    </div>
  );
}
